<template>
<div class="container-fluid">
	<div class="row">
	    <div class="col-12">
			<h1>Add Report</h1>
		</div>
	</div>

	<form @submit.prevent="submitForm" @keydown="form.onKeydown($event)" @change="form.onKeydown($event)" class="mb-0">
		<alert-errors :form="form">There were some problems with your input.</alert-errors>

		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-header">Settings</div>
					<div class="card-body row">
						<div class="col-md-auto">
							<label class="mb-0">Thumbnail</label>
							<file-field
								ref="thumbnail"	
								@file_changed="changedThumbnail($event)"
							/>
					    </div>
						<div class="col">				
						    <div class="form-group">
								<label class="mb-0">Title</label>
								<input class="form-control" v-model="form.title" required>
						    </div>
						    <div class="form-group">
								<label class="mb-0">Quicksight URL</label>
								<input class="form-control" v-model="form.dashboard_id" required>
						    </div>
						    
						    <div class="form-group">
							    <label class="mb-0">Height (with units: px or %) <span class="text-gray-500">- optional</span></label>
							    <input class="form-control" v-model="form.height">
						    </div>							    
						</div>
					</div>
				</div>
			</div>

			<div class="col-12">
				<div class="form-group">
					<span class="btn btn-ghost-secondary mr-1" @click="cancelEdit()">Cancel</span>
			    	<button type="submit" class="btn btn-primary">Create Report</button>
				</div>
			</div>
		</div>
	</form>	
</div>
</template>

<script>
	import { mapState } from 'vuex';
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';
	import { objectToFormData } from 'object-to-formdata'

	export default {
        mixins: [BreadcrumbsManager],

        components: {
        	HasError,
            AlertError,
            AlertErrors,
            AlertSuccess,
            Form
        },

		data() {
			return {
				form: {},
			}
		},

		created() {
			this.fillForm();			
		},

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Reports', to: { name: 'reports.index'} },
                { text: 'Create Report', to: { name: 'reports.create'} },
            ]);  
        },

		methods: {
			cancelEdit() {
				this.$router.go(-1);
			},

			changedThumbnail($event) {
				this.form.thumbnail = this.$refs.thumbnail.file;
			},

            fillForm() {
            	this.form = new Form({
					title: null,
					dashboard_id: null,
					height: null,
					thumbnail: null,
				});

            	//auto-set to proper client for non-admins
				if (!this.perms.can_do_everything) {
					this.form.client_list = [this.user.client_id];
				}
            },

        	submitForm() { 
				this.form.submit('post', '/api/reports', {
					transformRequest: [function (data, headers) {
						return objectToFormData(data)
					}],
				}).then(({ data }) => {
					Swal.fire({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 4000,
						icon: 'success',
						title: 'Report created',
					});						
					this.$router.push({ name: 'reports.index' });
				});     		
        	},
		},

		computed: {
			...mapState(['perms', 'user'])
		}
	}
</script>